import { body2 } from '@westwing/ui-kit/typography';
import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';

export const StyledWrapper = styled.section`
    border-bottom: 1px solid ${({ theme }) => theme.colors.charcoal20};
    &:last-child {
        border-bottom: none;
    }
`;

export const StyledList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

export const StyledTitle = styled.div`
    ${body2}
    padding: 30px 0 20px 0;
    color: ${({ theme }) => theme.colors.charcoal60};
    border-bottom: 1px solid ${({ theme }) => theme.colors.charcoal20};
    text-align: center;
`;

export interface NavSectionProps {
    title: string;
}

const NavSection: FC<NavSectionProps> = ({ title, children }): ReactElement => (
    <StyledWrapper>
        {title && <StyledTitle>{title}</StyledTitle>}
        <StyledList>{children}</StyledList>
    </StyledWrapper>
);

export default NavSection;
